import { render, staticRenderFns } from "./FullLogin.vue?vue&type=template&id=0c4fd360&"
import script from "./FullLogin.vue?vue&type=script&lang=ts&"
export * from "./FullLogin.vue?vue&type=script&lang=ts&"
import style0 from "./FullLogin.vue?vue&type=style&index=0&id=0c4fd360&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports